import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Input, Button } from 'reactstrap';
import axios from 'axios';
import logolight from "../../assets/images/logo_white.png"
import { toast } from "react-toastify";
const handleNavClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};
const Footer = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const handleSubscribe = async () => {
        if (!email) {
            toast.error('Please enter a valid email address.');
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/newsletter`, { email_id: email });
            if (response.status === 200) {
                toast.success('Thank you for subscribing. We will keep you updated.');
                setEmail('');
            }

        } catch (err) {
            toast.error('Failed to subscribe. Please try again later.');
        } finally {
            setLoading(false);
        }
    };
    return (
        <React.Fragment>
            <footer className="custom-footer py-3 position-relative" style={{ backgroundColor: " rgb(52, 81, 159)" }}>
                <Container>
                    <Row>
                        <Col lg={3} className="mt-4">
                            <div>
                                <img src={logolight} alt="Offiso Logo" height="40" />
                                <div className="mt-4">
                                    <p className='text-white'>
                                        OFFISO India is a distribution company headquartered in Pune.
                                        Formed with an intention to solve the recurring problem of having multiple
                                        suppliers in admin services by emerging as a single supplier for products
                                        of various brands catering corporate offices across pan India.
                                    </p>
                                </div>
                            </div>
                        </Col>

                        <Col lg={2} className="mt-4">
                            <h5 className="text-white">Sitemap</h5>
                            <ul className="list-unstyled mt-3">
                                <li className="mb-2"><Link to="/" className="text-white " onClick={handleNavClick}>Home</Link></li>
                                <li className="mb-2"><Link to="/about" className="text-white " onClick={handleNavClick}>About us</Link></li>
                                {/* <li className="mb-2"><Link to="/products" className="text-white " onClick={handleNavClick}>Products</Link></li> */}
                                <li className="mb-2"><Link to="/contact" className="text-white " onClick={handleNavClick}>Contact</Link></li>
                            </ul>
                        </Col>

                        <Col lg={4} className="mt-4">
                            <h5 className="text-white">Services</h5>
                            <Row>
                                {/* <Col xs={6}> */}
                                <ul className="list-unstyled mt-3">
                                    <li className="mb-2"><Link to="/services/tatamachine" className="text-white" onClick={handleNavClick}>Tata Coffee Machine</Link></li>
                                    <li className="mb-2"><Link to="/services/nescafemachine" className="text-white" onClick={handleNavClick}>Nescafé Vending Machine</Link></li>
                                    <li className="mb-2"><Link to="/services/snacksmachine" className="text-white" onClick={handleNavClick}>Snack Vending Machine</Link></li>
                                    <li className="mb-2"><Link to="/services/sanitorymachine" className="text-white" onClick={handleNavClick}>Sanitary Pad Vending Machine</Link></li>
                                    <li className="mb-2"><Link to="/services/tissuepapers" className="text-white" onClick={handleNavClick}>Tissue Paper</Link></li>
                                    <li className="mb-2"><Link to="/services/cleaningchemicals" className="text-white" onClick={handleNavClick}>Cleaning Chemicals</Link></li>
                                    {/* </ul>
                                </Col>
                                <Col xs={6}>
                                    <ul className="list-unstyled mt-3"> */}
                                    <li className="mb-2"><Link to="/services/housekeeping" className="text-white" onClick={handleNavClick}>Housekeeping</Link></li>
                                    <li className="mb-2"><Link to="/services/stationary" className="text-white" onClick={handleNavClick}>Stationary</Link></li>
                                    <li className="mb-2"><Link to="/services/plantOnRent" className="text-white" onClick={handleNavClick}>Plant on Rent</Link></li>
                                    <li className="mb-2"><Link to="/services/gifting" className="text-white" onClick={handleNavClick}>Corporate Gifting</Link></li>
                                    <li className="mb-2"><Link to="/services/boat" className="text-white" onClick={handleNavClick}>Boat Accessories</Link></li>
                                    <li className="mb-2"><Link to="/services/snacks" className="text-white" onClick={handleNavClick}>Ready-to-Eat Snacks</Link></li>
                                </ul>
                                {/* </Col> */}
                            </Row>
                        </Col>

                        <Col lg={3} className="mt-4">
                            <h5 className="text-white">Stay Connected</h5>
                            <div className="d-flex mt-3">
                                <Input type="email" placeholder="Enter your email*" value={email} onChange={(e) => setEmail(e.target.value)} className="me-2" />
                                <Button color="primary" onClick={handleSubscribe} disabled={loading}>
                                    {loading ? "Sending..." : "Send"}
                                </Button>
                            </div>
                            <div className="text-sm-end mt-3 ">
                                <ul className="list-inline mb-0 footer-social-link">
                                    <li className="list-inline-item">
                                        <Link to="https://www.linkedin.com/company/offiso-india/" className="avatar-xs d-block">
                                            <div className="avatar-title rounded-circle ">
                                                <i className="ri-linkedin-fill text-white"></i>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className="list-inline-item">
                                        <Link to="https://www.facebook.com/offisoindia" className="avatar-xs d-block">
                                            <div className="avatar-title rounded-circle">
                                                <i className="ri-facebook-fill text-white"></i>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className="list-inline-item">
                                        <Link to="https://www.instagram.com/offisoindia/" className="avatar-xs d-block">
                                            <div className="avatar-title rounded-circle">
                                                <i className="ri-instagram-fill text-white"></i>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>

                    <Row className="text-center text-sm-start align-items-center mt-5">
                        <Col sm={12}>
                            <div>
                                <p className="copy-rights mb-0  text-center text-white">
                                    &copy; {new Date().getFullYear()} Offiso India Distribution Pvt. Ltd. All Rights Reserved.
                                </p>
                            </div>
                        </Col>
                       
                    </Row>
                </Container>
            </footer>
        </React.Fragment >
    );
};
export default Footer;